import { Link } from 'react-router-dom';
import type { ExistingSessionInfo } from '../hooks/useExistingSession';

interface SessionResumeBannerProps {
  session: ExistingSessionInfo;
  onDismiss: () => void;
}

const CONFIG = {
  quiz: {
    emoji: '\u{1F4DD}',
    buttonText: 'Continue',
    getMessage: (otherName: string) => `You have an unfinished quiz with ${otherName}`,
  },
  waiting: {
    emoji: '\u23F3',
    buttonText: 'Check status',
    getMessage: (otherName: string) => `Waiting for ${otherName} to finish`,
  },
  results: {
    emoji: '\u{1F389}',
    buttonText: 'View results',
    getMessage: (otherName: string) => `Your results with ${otherName} are ready!`,
  },
} as const;

export default function SessionResumeBanner({ session, onDismiss }: SessionResumeBannerProps) {
  const { state, resumeUrl, partner, partnerAName, partnerBName } = session;
  const otherName = partner === 'A' ? partnerBName : partnerAName;
  const { emoji, buttonText, getMessage } = CONFIG[state];

  return (
    <div
      className="mb-6 rounded-2xl overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, rgba(255, 140, 66, 0.10) 0%, rgba(255, 51, 102, 0.07) 100%)',
        border: '2px solid rgba(255, 140, 66, 0.20)',
      }}
    >
      <div className="px-4 py-3 flex items-center gap-3">
        <span className="text-lg flex-shrink-0">{emoji}</span>
        <span className="text-sm font-semibold text-white flex-1 min-w-0">
          {getMessage(otherName)}
        </span>
        <Link
          to={resumeUrl}
          className="flex-shrink-0 px-3 py-1.5 gradient-cta rounded-lg text-xs font-semibold text-white whitespace-nowrap"
        >
          {buttonText}
        </Link>
        <button
          onClick={onDismiss}
          className="flex-shrink-0 p-1 text-white/30 hover:text-white transition-colors"
          aria-label="Dismiss"
        >
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}
